import { Check, X } from 'lucide-react'
import './ActiveMark.css'

/**
 * A yes/no state as a mark, for a table's active column (2026-10-22, the client's reference):
 * a green disc with a check when on, a rose disc with a cross when off. The word is not drawn
 * — the column header already names what is being answered — but it stays the mark's
 * accessible name and its tooltip, so nothing depends on telling green from red.
 *
 * @param {boolean} active
 * @param {string} label  the state in words, e.g. "نشط" / "غير نشط"
 */
export default function ActiveMark({ active, label }) {
  const Icon = active ? Check : X
  return (
    <span
      className={`active-mark active-mark--${active ? 'on' : 'off'}`}
      role="img"
      aria-label={label}
      title={label}
    >
      <Icon size={12} strokeWidth={3.25} aria-hidden="true" />
    </span>
  )
}
